import React from 'react'
import { Box, useTheme } from '@mui/material'

const SidebarSlidingIndicator = React.forwardRef<HTMLDivElement, { open: boolean; isCollapsing: boolean }>(
  ({ open }, ref) => {
    const theme = useTheme()

    return (
      <Box
        ref={ref}
        sx={{
          position: 'absolute',
          left: 0,
          width: open ? '100%' : 0,
          zIndex: 0,
          borderRadius: theme.spacing(1),
          backgroundColor: 'primary.light',
          boxShadow: 2,
          transition:
            'transform 300ms cubic-bezier(0.4,0,0.2,1), height 200ms cubic-bezier(0.4,0,0.2,1), opacity 200ms',
          pointerEvents: 'none',
          opacity: 0,
        }}
      />
    )
  }
)

export default SidebarSlidingIndicator
